import { useTheme } from "@material-ui/styles";
import {
  Grid,
  Link,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import logoSM from "images/solo-mujer-logo.png";



export default function SoloMujerForm() {
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <div style={{ width: isXl ? "100%" : "auto" }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: "100vh", p: 2 }}
      >
        <Grid item xs={12} sm={10} md={8} lg={6}>
          <Paper elevation={3} sx={{ p: 5, textAlign: "center" }}>
            <Stack spacing={3} alignItems="center">
              <img
                src={logoSM}
                alt="Solo Mujer"
                style={{ maxWidth: 180, height: "auto" }}
              />

              <Typography variant="body1">
                La descarga de cupones de <strong>Solo Mujer</strong> se encuentra deshabilitada desde el 
                <strong> 1 de Septiembre del 2026</strong>.
              </Typography>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}